<template>
  <div>
    <el-table
      ref="table"
      border
      highlight-current-row
      style="width: 100%"
      header-row-class-name="table-header"
      size="medium"
      :data="tableList"
      @sort-change="sortChange"
    >
      <el-table-column
        label="序号"
        prop="index"
        align="center"
        type="index"
        width="60"
      />
      <el-table-column
        v-if="isEntrust"
        label="项目名称"
        prop="entrustProjectName"
        align="center"
        min-width="150"
        show-overflow-tooltip
      />
      <el-table-column
        v-if="isEntrust"
        label="委托方"
        prop="entrustPurchaseCompanyName"
        align="center"
        min-width="150"
        show-overflow-tooltip
      />
      <el-table-column
        v-if="isEntrust"
        label="负责人"
        prop="entrustUserName"
        align="center"
        min-width="120"
        show-overflow-tooltip
      />
      <el-table-column
        label="竞价单名称"
        align="center"
        min-width="150"
        show-overflow-tooltip
      >
        <template slot-scope="{ row }">
          {{ row.competitionName || ' - ' }}
        </template>
      </el-table-column>
      <el-table-column
        label="竞价单编号"
        align="center"
        min-width="90"
        show-overflow-tooltip
      >
        <template slot-scope="{ row }">
          {{ row.competitionCode || ' - ' }}
        </template>
      </el-table-column>
      <el-table-column label="项目类型" align="center" min-width="100">
        <template slot-scope="{ row }">
          {{ projectTypeDict.translate(row.projectType).label || '-' }}
        </template>
      </el-table-column>
      <el-table-column label="竞价类型" align="center" min-width="100">
        <template slot-scope="{ row }">
          <div class="text-ellipsis">
            {{
              competeTypeDict.translate(row.competitionType)
                ? competeTypeDict.translate(row.competitionType).label
                : ' - '
            }}
          </div>
        </template>
      </el-table-column>
      <el-table-column
        label="发布日期"
        sortable="custom"
        prop="competitionReleaseTime"
        align="center"
        min-width="120"
      >
        <template slot-scope="{ row }">
          <div class="text-ellipsis">
            {{ row.competitionReleaseTime | getNormDayFilter }}
          </div>
        </template>
      </el-table-column>
      <el-table-column
        label="竞价开始时间"
        sortable="custom"
        prop="competitionStartTime"
        align="center"
        min-width="140"
      >
        <template slot-scope="{ row }">
          <div class="text-ellipsis">
            {{ row.competitionStartTime | getNormMinuteFilter }}
          </div>
        </template>
      </el-table-column>
      <el-table-column label="竞价状态" align="center" width="120">
        <template slot-scope="{ row }">
          <status-tag
            :type="competeStatusDict.translate(row.status).type"
            :label="competeStatusDict.translate(row.status).label"
            size="small"
          />
        </template>
      </el-table-column>
      <el-table-column label="供应商报名数" align="center" min-width="120">
        <template slot-scope="{ row }">
          {{
            row.signUpCount || row.signUpCount == 0
              ? `共${row.signUpCount}家`
              : '-'
          }}
        </template>
      </el-table-column>
      <el-table-column label="操作" align="center" fixed="right" width="160">
        <template slot-scope="{ row }">
          <el-button
            v-if="hasPermission(row.status, 'copy')"
            type="text"
            class="primary-button"
            size="small"
            @click="copyCompeteDetail(row)"
          >
            复制项目
          </el-button>
          <el-button
            v-if="hasPermission(row.status, 'detail')"
            type="text"
            class="info-button"
            size="small"
            @click="watchCompeteDetail(row)"
          >
            查看详情
          </el-button>
          <el-button
            v-if="hasPermission(row.status, 'edit')"
            type="text"
            size="small"
            class="primary-button"
            @click="edit(row)"
          >
            编辑
          </el-button>
          <el-button
            v-if="hasPermission(row.status, 'compete')"
            type="text"
            class="info-button"
            size="small"
            @click="watchCompeteDetail(row)"
          >
            进入大厅
          </el-button>
          <el-button
            v-if="hasPermission(row.status, 'delete')"
            type="text"
            size="small"
            class="danger-button"
            @click="deleteCompete(row)"
          >
            删除
          </el-button>
        </template>
      </el-table-column>
    </el-table>

    <pagination
      v-show="total > 0"
      ref="pagination"
      :total="total"
      :page.sync="page"
      :limit.sync="size"
      @pagination="getList"
    />
  </div>
</template>
<script>
import Pagination from '@/components/common/Pagination'
import StatusTag from '@/components/common/StatusTag.vue'

import { getCompeteListApi, deleteCompeteApi } from '@/api/procure/compete'

import {
  competeStatusDict,
  competeTypeDict
} from '@/dictionary/project/compete'
import { projectTypeDict } from '@/dictionary/project/common'
import { workbenchServiceDict } from '@/dictionary/system'
import { mapState } from 'vuex'

export default {
  components: {
    Pagination,
    StatusTag
  },

  props: {
    filterForm: {
      type: Object,
      default: () => {}
    },

    fetchApi: {
      type: Function,
      default: getCompeteListApi
    },

    // 是否是委托项目
    isEntrust: {
      type: Boolean,
      default: false
    },

    pageNum: {
      type: [String, Number],
      default: 1
    },

    pageSize: {
      type: [String, Number],
      default: 10
    }
  },

  data() {
    return {
      tableList: [],
      total: 0,
      competeStatusDict,
      competeTypeDict,
      projectTypeDict
    }
  },

  computed: {
    ...mapState('router', ['currentWorkbench']),

    page: {
      get() {
        return this.pageNum
      },
      set(val) {
        this.$emit('update:pageNum', val)
      }
    },

    size: {
      get() {
        return this.pageSize
      },
      set(val) {
        this.$emit('update:pageSize', val)
      }
    },

    // 代理机构加上Agency
    entrustRouter() {
      if (this.currentWorkbench === workbenchServiceDict.AGENCY.value) {
        return 'Agency'
      }
      return ''
    },

    // 委托项目id
    projectId() {
      return this.$route.params.projectId || ''
    }
  },

  activated() {
    this.getList()
  },

  methods: {
    // 返回表格的每一行是否有某些操作
    hasPermission(status, buttonType) {
      if (!competeStatusDict.translate(status).permission) return false

      const operateList = competeStatusDict.translate(status).permission
      return operateList.includes(buttonType)
    },

    // 获取表格数据
    getList() {
      this.fetchApi(
        Object.assign(this.filterForm, { page: this.page, size: this.size })
      )
        .then(res => {
          if (res.data) {
            this.tableList = res.data.records || []
            this.total = res.data.total
          } else {
            this.tableList = []
            this.total = 0
          }
        })
        .catch(err => {
          this.$message.error(err.message)
        })
    },

    // 删除未发布的竞价单
    deleteCompete(row) {
      this.$systemConfirm('此操作将永久删除该竞价单, 是否继续?').then(
        result => {
          if (!result) return

          deleteCompeteApi(row.orderId)
            .then(res => {
              this.getList()
              this.$message.success('删除成功')
            })
            .catch(err => {
              this.$message.error(err.message)
            })
        }
      )
    },

    // 编辑
    edit(row) {
      this.$router.push({
        name: this.entrustRouter + 'CreateCompete',
        params: { orderId: row.orderId, projectId: row.projectId }
      })
    },

    // 点击查看详情，进入项目进度
    watchCompeteDetail(row) {
      const routerName = competeStatusDict.translate(row.status).routerName

      this.$router.push({
        name: this.entrustRouter + routerName,
        params: { orderId: row.orderId }
      })
    },

    // 复制项目
    copyCompeteDetail(row) {
      this.$confirm(`复制 “${row.competitionName}” 的竞价信息`, '复制项目', {
        confirmButtonText: '确定复制',
        cancelButtonText: '取消',
        type: 'warning',
        center: true
      }).then(() => {
        this.$router.push({
          name: this.entrustRouter + 'CreateCompete',
          params: {
            orderId: row.orderId,
            projectId: row.projectId,
            isCopy: true
          }
        })
      })
    },

    /**
     * 按顺序排序
     */
    sortChange(column, prop, order) {
      this.filterForm.sortBy = column.prop
        .replace(/([A-Z])/g, '_$1')
        .toLowerCase()
      if (column.order == 'ascending') {
        this.filterForm.sortType = 'asc'
      } else if (column.order == 'descending') {
        this.filterForm.sortType = 'desc'
      } else {
        this.filterForm.sortType = undefined
      }
      this.getList()
    }
  }
}
</script>
